module.exports = __webpack_public_path__ + "static/media/completed-box.28275cd0.svg";